import { environment } from '../../../../apps/app/src/environments/environment';



export const CONSTANTS = {
	baseUrl: environment.baseUrl,
	url: 'https://mynatomame.cz',
	imageMetaStyle: ['/default/files/', '/default/files/styles/background_800/public/']
};

export const BUFFER = 4;

export const sortOptions = [
	{
		value: 'created-DESC',
		label: 'nejnovější',
		description: 'nejnovějšího'
	},
	{
		value: 'created-ASC',
		label: 'nejstarší',
		description: 'nejstaršího'
	},
	{
		value: 'title-ASC',
		label: 'abc',
		description: 'názvu vzestupně - ABC'
	},
	{
		value: 'title-DESC',
		label: 'zyx',
		description: 'názvu sestupně - ZYX'
	}/*,
	{
		value: 'field_event-ASC',
		label: 'nadcházející',
		description: 'data konání - NADCHÁZEJÍCÍ'
	}*/
];

export const sortWeight = {
	value: 'weight-ASC',
	label: 'Weight',
	description: 'priority'
};


export const HOLDINGPAGES = [
	'sneni',
	'webinar',
	'blog',
	'navigace',
	'kontakt',
	'tym',
	'gdpr'
];

export const ABOUT = {
	entityLabel: 'O nás',
	entityUrl: {
		path: 'o-nas'
	}
};

export type BackgroundStyle = 'screen'  | 'card_big' | 'card' | 'thumbnail' | 'default';

export const IMAGE_STYLES = {
	replace_pattern: '/default/files/',

	backround_sizes: {
		screen: '100vw',
		/*inline_image: '(max-width: 60em) calc(100vw - 4em), calc(100vw - 30em)',*/
		card_big: '(max-width: 40em) calc(100vw - 2em), (max-width: 70em) calc(50vw - 5em), calc(33.33vw - 8em)',
		card: '(max-width: 40em) calc(100vw - 2em), (max-width: 50em) calc(50vw - 3em), (max-width: 70em) calc(33.33vw - 3em), calc(25vw -5em)',
		thumbnail: '(max-width: 40em) calc(100vw - 2em), (max-width: 50em) calc(50vw - 3em), (max-width: 70em) calc(33vw - 3em), calc(25vw - 5em)',
		default: ''
	},
	backround_sizes_img: [
		'300w',
		'500w',
		'800w',
		'1200w',
		'1600w'
	],
	background_sizes_jpg: [
		'/default/files/styles/background_300/public/',
		'/default/files/styles/background_500/public/',
		'/default/files/styles/background_800/public/',
		'/default/files/styles/background_1200/public/',
		'/default/files/styles/background_1600/public/',
	],
	background_sizes_webp: [
		'/default/files/styles/background_300_webp/public/',
		'/default/files/styles/background_500_webp/public/',
		'/default/files/styles/background_800_webp/public/',
		'/default/files/styles/background_1200_webp/public/',
		'/default/files/styles/background_1600_webp/public/',
	],
	background_default: '/default/files/styles/background_300/public/'
};

